import { render, staticRenderFns } from "./ContactSupportEmailDialog.vue?vue&type=template&id=c8dfd5bc&scoped=true&"
import script from "./ContactSupportEmailDialog.vue?vue&type=script&lang=js&"
export * from "./ContactSupportEmailDialog.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=c8dfd5bc&scoped=true&lang=css&"
import style1 from "./ContactSupportEmailDialog.vue?vue&type=style&index=1&id=c8dfd5bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8dfd5bc",
  null
  
)

export default component.exports